module.exports = __webpack_public_path__ + "img/icon-shansuan-logo.55899761.png";